// The admin app's record of the impersonation it started (task 13 assumption, from the task's spec gaps): the id is
// kept in this tab's `sessionStorage`, so admin sign-out can end an open session with #58 `?reason=sign_out`
// (T-A05-02). The tab returns here after Exit (same-tab hand-off, D-40), where the notice clears it.

export const ADMIN_IMPERSONATION_KEY = 'pa.adminImpersonation'

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

function storage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage
  } catch {
    return null
  }
}

export function readStartedImpersonation(): string | null {
  try {
    const id = storage()?.getItem(ADMIN_IMPERSONATION_KEY) ?? null
    return id && UUID.test(id) ? id : null
  } catch {
    return null
  }
}

export function rememberStartedImpersonation(id: string): void {
  try {
    storage()?.setItem(ADMIN_IMPERSONATION_KEY, id)
  } catch {
    // no storage: sign-out can't end it, the 60-minute limit still does
  }
}

export function forgetStartedImpersonation(): void {
  try {
    storage()?.removeItem(ADMIN_IMPERSONATION_KEY)
  } catch {
    // nothing stored
  }
}

/** S-06 step 3: the clinic app's landing, with the id in the fragment (never sent to a server, D-40). */
export const clinicLandingHref = (clinicOrigin: string, id: string) => `${clinicOrigin}/impersonate#imp=${id}`

/** S-06 confirmation copy (Frontend §7.3 step 1; UserFlows S-06 step 2). */
export const actAsCopy = (clinicName: string) => ({
  title: 'Act as clinic admin?',
  body: `You'll have full Clinic Admin access to ${clinicName}. Everything you do is logged.`,
})
